// Replaces lookalike-space Unicode chars that break latin1/utf8mb3 DB columns with a regular space.
// U+2800 BRAILLE PATTERN BLANK is commonly pasted from WhatsApp/Telegram; the rest are zero-width variants.
export function sanitizeReportText (text) {
  return (text || '').replace(/[⠀​‌‍⁠﻿­]/g, ' ').replace(/\r\n/g, '\n').replace(/\r/g, '\n')
}
